import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { DatePicker, message, Select } from 'antd';
import { getChartWarningSelection } from '../../../ChartCalls';
import { DatePickerSlider } from '../../../CSS/style';
import SliderWarning from './SliderWarning';
import StyledTable from '../../../../../../commons/styles/table';

const { RangePicker } = DatePicker;
const { Option } = Select;

const WarningLine = (props) => {
  const { graphprops, deviceId, dropdownSelection, AssetCode, currentTimeZone } = props;
  const [tableData, setTableData] = useState([]);
  const [previousTableData, setPreviousTableData] = useState([]);
  const [selectionDateRange, setSelectionDateRange] = useState({
    startDate: moment().subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss'),
    endDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    timeBucket: '1m',
    warningDevice: '',
    warningParameter: '',
    warningGraphType: 'line'
  });
  const [selectionDateRangePrevious, setSelectionDateRangePrevious] = useState({
    startDate: moment().subtract(1, 'day').format('YYYY-MM-DD 00:00:00'),
    endDate: moment().subtract(1, 'day').format('YYYY-MM-DD 23:59:59'),
    timeBucket: '1m',
    warningDevice: '',
    warningParameter: '',
    warningGraphType: 'line'
  });
  const setWarningDevice = useState('');
  const [warningParameter, setWarningParameter] = useState('');
  const [selectedDateRange, setSelectedDateRange] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const abortController = useRef(new AbortController());

  useEffect(() => {
    setData();
  }, [graphprops]);

  const setData = () => {
    let warningList = graphprops?.warningList ? JSON.parse(graphprops.warningList) : [];
    let device = warningList.length > 0 ? warningList[0].device : '';
    let parameter = warningList.length > 0 ? warningList[0].parameter : '';

    setSelectionDateRange((prev) => ({
      ...prev,
      warningDevice: device,
      warningParameter: parameter
    }));

    setSelectionDateRangePrevious((prev) => ({
      ...prev,
      warningDevice: device,
      warningParameter: parameter
    }));

    _getTableData(
      { ...selectionDateRange, warningGraphType: 'table' },
      { ...selectionDateRangePrevious, warningGraphType: 'table' }
    );
  };

  const _getTableData = async (currentSelectionDateRange, previousSelectionDateRange) => {
    let warningList = graphprops?.warningList ? JSON.parse(graphprops.warningList) : [];
    let device = warningList.length > 0 ? warningList[0].device : '';
    let parameter = warningList.length > 0 ? warningList[0].parameter : '';

    if (currentSelectionDateRange) {
      const tableDataResponse = await getChartWarningSelection({
        graphprops: { ...graphprops, warningList, warningDevice: device, warningParameter: parameter },
        DeviceCode: props.DeviceCode,
        selectionDateRange: currentSelectionDateRange,
        abortController: abortController.current,
        dropdownSelection,
        dashboardPayload: props.dashboardPayload,
        AssetCode,
        currentTimeZone
      });
      setTableData(tableDataResponse);
    }

    if (previousSelectionDateRange) {
      const previousTableDataResponse = await getChartWarningSelection({
        graphprops: { ...graphprops, warningList, warningDevice: device, warningParameter: parameter },
        DeviceCode: props.DeviceCode,
        selectionDateRange: previousSelectionDateRange,
        abortController: abortController.current,
        dropdownSelection,
        dashboardPayload: props.dashboardPayload,
        AssetCode,
        currentTimeZone
      });
      setPreviousTableData(previousTableDataResponse);
    }
  };

  useEffect(() => {
    return () => {
      abortController.current.abort();
    };
  }, []);

  const onDateRangePickerChange = async (currentDate) => {
    if (currentDate && currentDate[0] && currentDate[1]) {
      const newSelectionDateRange = {
        ...selectionDateRange,
        startDate: currentDate[0].format('YYYY-MM-DD HH:mm:ss'),
        endDate: currentDate[1].format('YYYY-MM-DD HH:mm:ss'),
        timeBucket: '1m'
      };
      await _getTableData({ ...newSelectionDateRange, warningGraphType: 'table' });
      setSelectionDateRange(newSelectionDateRange);
      setSelectedDateRange(false);
      setInitialRender(false);
    }
  };

  const disabledDate = (current) => {
    return current > moment().endOf('day');
  };

  const deviceSelect = (parameter) => {
    let warningList = graphprops?.warningList ? JSON.parse(graphprops.warningList) : [];
    let warningObject = warningList.find((warn) => warn.parameter === parameter) || {};
    const newSelectionDateRange = {
      ...selectionDateRange,
      warningDevice: warningObject.device,
      warningParameter: warningObject.parameter
    };
    const newSelectionDateRangePrevious = {
      ...selectionDateRangePrevious,
      warningDevice: warningObject.device,
      warningParameter: warningObject.parameter
    };
    _getTableData(
      { ...newSelectionDateRange, warningGraphType: 'table' },
      { ...newSelectionDateRangePrevious, warningGraphType: 'table' }
    );
    setWarningDevice(warningObject.device);
    setWarningParameter(warningObject.parameter);
    setSelectionDateRange(newSelectionDateRange);
    setSelectionDateRangePrevious(newSelectionDateRangePrevious);
    setSelectedDateRange(false);
    setInitialRender(true);
  };

  const SendSelectedDateRange = async (dateRange) => {
    let startDate = moment(dateRange.startDate, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
    let endDate = moment(dateRange.endDate, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

    if (startDate && endDate && startDate !== 'Invalid date' && endDate !== 'Invalid date') {
      const newSelectionDateRangePrevious = {
        ...selectionDateRangePrevious,
        startDate,
        endDate,
        timeBucket: '1m'
      };
      await _getTableData(undefined, { ...newSelectionDateRangePrevious, warningGraphType: 'table' });
      setSelectedDateRange(true);
      setSelectionDateRangePrevious(newSelectionDateRangePrevious);
    } else {
      message.error('Error in selection');
    }
  };

  const columns = [
    {
      title: 'Warning limits',
      dataIndex: 'Warning Limits',
      key: 'Warning Limits'
    },
    {
      title: 'Number of Count',
      dataIndex: 'Number of Count',
      key: 'Number of Count'
    },
    {
      title: 'Total Time in Mins',
      dataIndex: 'Total Time in mins',
      key: 'Total Time in mins'
    }
  ];

  return (
    <div style={{ height: '70%', marginTop: '40px', display: 'inline-block', width: '100%' }}>
      <DatePickerSlider>
        <Select style={{ width: 300 }} value={warningParameter} onChange={deviceSelect}>
          {graphprops?.warningList && Array.isArray(graphprops.warningList) &&
            graphprops.warningList.map((warning, index) => (
              <Option key={index} value={warning.parameter}>
                {warning.parameterName}
              </Option>
            ))}
        </Select>
        <RangePicker
          format="YYYY-MM-DD HH:mm:ss"
          showTime
          placeholder={['Start Date', 'End Date']}
          onChange={onDateRangePickerChange}
          disabledDate={disabledDate}
          value={[moment(selectionDateRange.startDate), moment(selectionDateRange.endDate)]}
          ranges={{
            Today: [moment().startOf('day'), moment()],
            'This Month': [moment().startOf('month'), moment()],
            'Last Month': [
              moment().subtract(1, 'month').startOf('month'),
              moment().subtract(1, 'month').endOf('month')
            ]
          }}
          style={{
            width: '400px',
            cursor: 'pointer'
          }}
        />
      </DatePickerSlider>

      {graphprops && graphprops.title ? (
        <div style={{ width: selectedDateRange ? '45%' : '100%', float: 'left' }}>
          <SliderWarning
            graphprops={graphprops}
            dropdownSelection={dropdownSelection}
            deviceId={deviceId}
            selectionDateRange={selectionDateRange}
            sendSelectedDateRange={SendSelectedDateRange}
            initialRender={initialRender}
          />
          <StyledTable size="small"
            style={{ padding: '55px' }}
            dataSource={Array.isArray(tableData) ? tableData : []}
            columns={columns}
          />
        </div>
      ) : null}

      {selectedDateRange && graphprops && graphprops.title ? (
        <div>
          <div style={{ width: '45%', float: 'right' }}>
            <SliderWarning
              graphprops={graphprops}
              dropdownSelection={dropdownSelection}
              deviceId={deviceId}
              selectionDateRange={selectionDateRangePrevious}
              sendSelectedDateRange={() => {}}
              initialRender={initialRender}
            />
            <StyledTable size="small"
              style={{ padding: '55px' }}
              dataSource={Array.isArray(previousTableData) ? previousTableData : []}
              columns={columns}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default WarningLine;